import React from 'react';

const SvgCheckedOutManual: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg
    viewBox="-7 -4 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <defs>
      <filter colorInterpolationFilters="auto" id="filter-1">
        <feColorMatrix
          in="SourceGraphic"
          type="matrix"
          values="0 0 0 0 0.164706 0 0 0 0 0.184314 0 0 0 0 0.211765 0 0 0 1.000000 0"
        />
      </filter>
      <filter colorInterpolationFilters="auto" id="filter-2">
        <feColorMatrix
          in="SourceGraphic"
          type="matrix"
          values="0 0 0 0 0.164706 0 0 0 0 0.184314 0 0 0 0 0.211765 0 0 0 1.000000 0"
        />
      </filter>
    </defs>
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Events" transform="translate(-1231.000000, -245.000000)">
        <g id="Group-23" transform="translate(559.000000, 90.000000)">
          <g id="Group-19-Copy" transform="translate(672.000000, 155.000000)">
            <g id="Group-23-Copy">
              <g filter="none" id="corner-2">
                <g transform="translate(0.000000, 3.032081)">
                  <path
                    d="M0,8.20536441 C0,10.831454 2.25704179,12.9679186 5.03130136,12.9679186 C7.80556093,12.9679186
                    10.0626027,10.831454 10.0626027,8.20536441 L10.0626027,6.48395929 C10.0626027,5.7720722 9.44704586,5.19290545
                    8.69042962,5.19290545 C8.51183366,5.19290545 8.34131829,5.22549739 8.18467711,5.28416861 C8.02596242,4.73630274
                    7.49276644,4.33220289 6.86086549,4.33220289 C6.68226953,4.33220289 6.51175416,4.36479483 6.35511298,4.42346605
                    C6.19639829,3.87560018 5.66320231,3.47150033 5.03130136,3.47150033 C4.87097055,3.47150033 4.71707372,3.49775176
                    4.57391032,3.54552075 L4.57391032,1.29105384 C4.57391032,0.579166753 3.95835347,0 3.20173723,0 C2.44512098,0
                    1.82956413,0.579166753 1.82956413,1.29105384 L1.82956413,4.40622331 C1.68640074,4.35845432 1.5325039,4.33220289
                    1.3721731,4.33220289 C0.615556851,4.33220289 0,4.91136964 0,5.62325673 L0,8.20536441 Z M0.914782065,5.62325673
                     C0.914782065,5.38596104 1.11996768,5.19290545 1.3721731,5.19290545 C1.62437851,5.19290545 1.82956413,5.38596104
                     1.82956413,5.62325673 L1.82956413,8.6357157 L2.74434619,8.6357157 C2.74434619,7.6414321 2.74434619,1.53262436
                     2.74434619,1.29105384 C2.74434619,1.05375815 2.94953181,0.860702561 3.20173723,0.860702561 C3.45394264,0.860702561
                     3.65912826,1.05375815 3.65912826,1.29105384 L3.65912826,6.91431057 L4.57391032,6.91431057 L4.57391032,4.76255417
                     C4.57391032,4.52525847 4.77909594,4.33220289 5.03130136,4.33220289 C5.28350677,4.33220289 5.48869239,4.52525847
                     5.48869239,4.76255417 L5.48869239,6.91431057 L6.40347445,6.91431057 L6.40347445,5.62325673 C6.40347445,5.38596104
                      6.60866007,5.19290545 6.86086549,5.19290545 C7.1130709,5.19290545 7.31825652,5.38596104 7.31825652,5.62325673
                      L7.31825652,6.91431057 L8.23303858,6.91431057 L8.23303858,6.48395929 C8.23303858,6.2466636 8.4382242,6.05360801
                      8.69042962,6.05360801 C8.94263503,6.05360801 9.14782065,6.2466636 9.14782065,6.48395929 L9.14782065,8.20536441
                      C9.14782065,10.3568626 7.30115009,12.107216 5.03130136,12.107216 C2.76145262,12.107216 0.914782065,10.3568626
                      0.914782065,8.20536441 L0.914782065,5.62325673 Z"
                    id="Shape"
                    fill="#2A2F36"
                    fillRule="nonzero"
                  />
                </g>
              </g>
              <g id="round" transform="translate(6.925926, 0.000000)" />
            </g>
            <g filter="none" id="Group-Copy">
              <g transform="translate(6.000000, 1.000000)">
                <path
                  d="M3.21878863,4.82540062 C3.33992583,4.94259746 3.49814586,5 3.65636588,5 C3.81458591,5 3.97280593,4.94259746
                  4.09394314,4.82540062 L5.64894932,3.32097584 C5.87639061,3.10093279 6,2.80913657 6,2.50059794 C6,2.19205932
                  5.87391842,1.89787132 5.64894932,1.68022004 L4.09394314,0.175795264 C3.85166873,-0.0585984214 3.46106304,
                  -0.0585984214 3.21878863,0.175795264 C2.97651422,0.41018895 2.97651422,0.788088974 3.21878863,1.02248266
                  L4.13102596,1.90504664 L0.618046972,1.90504664 C0.276885043,1.90504664 0,2.17292514 0,2.50298972 C0,2.83305429
                  0.276885043,3.10093279 0.618046972,3.10093279 L4.13349815,3.10093279 L3.22126082,3.98349677 C2.9789864,
                  4.21310691 2.9789864,4.59100694 3.21878863,4.82540062 L3.21878863,4.82540062 Z"
                  id="Combined-Shape"
                  fill="#2A2F36"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default SvgCheckedOutManual;
